export default __webpack_public_path__ + "static/media/Regulatory3.3df71834.png";